import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MonitorPlayIcon, UsersIcon } from 'lucide-react';
import type { Formation } from '../types/formation';
import { afficherTarifs } from '../data/site';
interface FormationCardProps {
  formation: Formation;
}
export function FormationCard({
  formation
}: FormationCardProps) {
  return <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-surface-line bg-white shadow-card transition-shadow duration-200 ease-out hover:shadow-lift" data-id="element-78" data-mp="2h1bxctirri06">
      <img src={formation.image} alt="" aria-hidden className="h-44 w-full object-cover" data-id="element-79" data-mp="2qvlvkrue7ait" />
      <div className="flex flex-1 flex-col p-6" data-id="element-80" data-mp="2zy4rerzrgmvk">
        <span className="w-fit rounded-md bg-brand-50 px-2.5 py-1 text-xs font-semibold text-brand-700" data-id="element-81" data-mp="2zwtnms6bff4g">
          {formation.categorie}
        </span>

        <h3 className="mt-4 text-xl font-bold leading-snug text-ink" data-id="element-82" data-mp="15ju44nyte0rw">
          <Link to={`/formations/${formation.slug}`} className="transition-colors duration-150 ease-out group-hover:text-accent-600" data-id="element-83" data-mp="15m6lp00nu94f">
            {formation.titre}
          </Link>
        </h3>
        <p className="mt-2.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-84" data-mp="2i0iu7c40diqv">{formation.promesse}</p>

        <dl className="mt-5 space-y-2.5 text-sm" data-id="element-85" data-mp="2d1xsf893yr0b">
          <div className="flex gap-2.5" data-id="element-86" data-mp="2d38y5dm468u2">
            <dt className="shrink-0 pt-0.5 text-ink-faint" data-id="element-87" data-mp="39rybqrqpkfa8">
              <UsersIcon size={15} aria-hidden data-id="element-88" data-mp="39rey3n83cd20" />
              <span className="sr-only" data-id="element-89" data-mp="35qmo2rrea44o">Public concerné</span>
            </dt>
            <dd className="text-ink-muted" data-id="element-90" data-mp="35oignzuaemzn">{formation.publicConcerne}</dd>
          </div>
          <div className="flex gap-2.5" data-id="element-91" data-mp="30tcwp6kg3ie7">
            <dt className="shrink-0 pt-0.5 text-ink-faint" data-id="element-92" data-mp="2vsypfqqo4ch8">
              <ClockIcon size={15} aria-hidden data-id="element-93" data-mp="2vujjlf92ltek" />
              <span className="sr-only" data-id="element-94" data-mp="1pd4s6zlgdwzw">Durée</span>
            </dt>
            <dd className="text-ink-muted" data-id="element-95" data-mp="1kda391l8nhhh">
              {formation.duree}
              {formation.dureeNote && <span className="ml-1.5 rounded bg-amber-50 px-1.5 py-0.5 text-xs font-medium text-amber-700" data-id="element-96" data-mp="1ltxmfl28t1sr">
                  nombre de jours à confirmer
                </span>}
            </dd>
          </div>
          <div className="flex gap-2.5" data-id="element-97" data-mp="1csps1e2ukl3y">
            <dt className="shrink-0 pt-0.5 text-ink-faint" data-id="element-98" data-mp="1hskgzc32b0md">
              <MonitorPlayIcon size={15} aria-hidden data-id="element-99" data-mp="1hr10plheopkl" />
              <span className="sr-only" data-id="element-100" data-mp="13365nyfxe94c">Format</span>
            </dt>
            <dd className="text-ink-muted" data-id="element-101" data-mp="131v29zqe73dr">{formation.format}</dd>
          </div>
        </dl>

        <div className="mt-auto flex items-end justify-between gap-4 border-t border-surface-line pt-5" data-id="element-102" data-mp="17whgsbrrtc22">
          <p data-id="element-103" data-mp="u16mp0lcouyr">
            <span className="block text-xs text-ink-faint" data-id="element-104" data-mp="y4l7e4k8hzij">Tarif</span>
            <span className="text-lg font-bold text-brand-900" data-id="element-105" data-mp="y2iglib9c2cr">
              {afficherTarifs ? formation.tarif : 'Sur devis'}
            </span>
          </p>
          <Link to={`/formations/${formation.slug}`} className="inline-flex items-center gap-1.5 rounded-lg bg-brand-900 px-4 py-2.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-800" data-id="element-106" data-mp="p2vdms2vqohl">
            Découvrir la formation
            <ArrowRightIcon size={15} aria-hidden data-id="element-107" data-mp="fgkncblytrat" />
          </Link>
        </div>
      </div>
    </article>;
}